var _a;
import * as Sentry from "@sentry/browser";
import { default as React } from "react";
import "react-app-polyfill/ie11";
import ReactDom from "react-dom/client";
import smoothscroll from "smoothscroll-polyfill";
import { getArea } from "../shared/getArea";
import ClassList from "./components/ClassList";
// kick off the polyfill!
smoothscroll.polyfill();
Sentry.init({
    dsn: process.env.SENTRY_DSN,
    release: process.env.VERSION,
});
const ele = document.getElementById("class-list");
if (ele) {
    const root = ReactDom.createRoot(ele);
    root.render(React.createElement(ClassList, { area: getArea(), teacher: (_a = ele === null || ele === void 0 ? void 0 : ele.dataset.teacherList) !== null && _a !== void 0 ? _a : "" }));
}
